var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatCalculationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5093_40664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2695 3H5.26953C4.16953 3 3.26953 3.9 3.26953 5V19C3.26953 20.1 4.16953 21 5.26953 21H19.2695C20.3695 21 21.2695 20.1 21.2695 19V5C21.2695 3.9 20.3695 3 19.2695 3ZM19.2695 19H5.26953V5H19.2695V19Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5195 7.71973H6.51953V9.21973H11.5195V7.71973Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2695 15.75H13.2695V17.25H18.2695V15.75Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2695 13.25H13.2695V14.75H18.2695V13.25Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26953 18H9.76953V16H11.7695V14.5H9.76953V12.5H8.26953V14.5H6.26953V16H8.26953V18Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3598 10.95L15.7698 9.54L17.1798 10.95L18.2398 9.89L16.8298 8.47L18.2398 7.06L17.1798 6L15.7698 7.41L14.3598 6L13.2998 7.06L14.7098 8.47L13.2998 9.89L14.3598 10.95Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5093_40664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.269531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatCalculationIcon);
export default __webpack_public_path__ + "static/media/heat-calculation-icon.bfb2e765371ffb52eaa49caff905452b.svg";
export { ForwardRef as ReactComponent };